import Vue from 'vue'

import vuetify from './plugins/vuetify';
import router from './router'

import BootstrapVue from "bootstrap-vue"

import App from './App'

import Default from './Layout/Wrappers/baseLayout.vue';
import Pages from './Layout/Wrappers/pagesLayout.vue';
import Apps from './Layout/Wrappers/appLayout.vue';

import axios from 'axios';
import qs from 'qs';
Vue.prototype.$qs = qs //即可直接使用  this.$qs

// import './permission' // permission control

// 设置 axios，把请求数据在这里转换一下，参考官方文档： https://github.com/axios/axios
axios.defaults.transformRequest = [(data) => {
  return qs.stringify(data);
}]

Vue.config.productionTip = false;
Vue.prototype.$http = axios


Vue.use(BootstrapVue);

Vue.component('default-layout', Default);
Vue.component('userpages-layout', Pages);
Vue.component('apps-layout', Apps);



new Vue({
  el: '#app',
  router,
  vuetify,
  template: '<App/>',
  components: { App }
});
